import React from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/logo-spotify.svg";

function Footer() {
  return (
    <div className="footer bg-black pt-12 pb-8 px-4 sm:px-5">
      <div className="flex justify-between px-8">
        <div className="mb-10">
          <img src={logo} alt="logo" className="h-8" />
        </div>
        <div className="space-x-4 hidden lg:block">
          <ion-icon
            class="cursor-pointer p-2 text-white bg-gray-900 border-solid rounded-full  hover:text-green-500 transition duration-200"
            name="logo-instagram"
            size="large"
          ></ion-icon>
          <ion-icon
            class="cursor-pointer p-2 text-white bg-gray-900 border-solid rounded-full  hover:text-green-500 transition duration-200"
            name="logo-twitter"
            size="large"
          ></ion-icon>
          <ion-icon
            class="cursor-pointer p-2 text-white bg-gray-900 border-solid rounded-full  hover:text-green-500 transition duration-200"
            name="logo-facebook"
            size="large"
          ></ion-icon>
        </div>
      </div>

      <div className="md:flex md:flex-row justify-evenly">
        <ul className=" font-medium text-sm text-white flex flex-col gap-5 mb-10">
          <li className="font-bold text-sm text-gray-700 uppercase">Company</li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">About</Link>
          </li>
          <li className="  hover:text-green-500 transition duration-200">
            <Link to="/">Jobs</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">For the Record</Link>
          </li>
        </ul>
        <ul className="font-medium text-sm text-white flex flex-col gap-5 mb-10">
          <li className="font-bold text-sm text-gray-700">COMMUNITIES</li>
          <li className="  hover:text-green-500 transition duration-200">
            <Link to="/">For Artists</Link>
          </li>
          <li className="  hover:text-green-500 transition duration-200">
            <Link to="/">Developers</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">Advertising</Link>
          </li>
          <li className="  hover:text-green-500 transition duration-200">
            <Link to="/">Investors</Link>
          </li>
          <li className="  hover:text-green-500 transition duration-200">
            <Link to="/">Vendors</Link>
          </li>
        </ul>
        <ul className="font-medium text-sm text-white flex flex-col gap-5">
          <li className="font-bold text-sm text-gray-700">USEFUL LINKS</li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">Support</Link>
          </li>
          <li className="  hover:text-green-500 transition duration-200">
            <Link to="/">Web Player</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">Free Mobile App</Link>
          </li>
        </ul>
      </div>

      <div className="pt-8 space-x-4 mt-8 lg:hidden">
        <ion-icon
          class="cursor-pointer p-2 text-white bg-gray-900 border-solid rounded-full  hover:text-green-500 transition duration-200"
          name="logo-instagram"
          size="large"
        ></ion-icon>
        <ion-icon
          class="cursor-pointer p-2 text-white bg-gray-900 border-solid rounded-full  hover:text-green-500 transition duration-200"
          name="logo-twitter"
          size="large"
        ></ion-icon>
        <ion-icon
          class="cursor-pointer p-2 text-white bg-gray-900 border-solid rounded-full  hover:text-green-500 transition duration-200"
          name="logo-facebook"
          size="large"
        ></ion-icon>
      </div>

      <div className="float-right md:text-xs text-[0.6rem] text-gray-500">
        <span className="hover:text-green-500 transition duration-200">
          <ion-icon class="text-white" name="earth-outline"></ion-icon>
          <Link to="/">Nigeria</Link>
        </span>
      </div>

      <div className="text-[0.6rem] md:text-xs text-gray-500 mt-6 flex justify-between">
        <ul className="grid grid-cols-3 gap-x-2 sm:flex">
          <li className="flex-shrink-0 hover:text-green-500 transition duration-200">
            <Link to="/">Legal</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">Privacy Center</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">Privacy Policy</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">Cookies</Link>
          </li>
          <li className=" hover:text-green-500 transition duration-200">
            <Link to="/">About Ads</Link>
          </li>
        </ul>
        <p className="">© 2023 Spotify AB</p>
      </div>
    </div>
  );
}

export default Footer;
